import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["shouldFocusWrap"];
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useId as $1Hnir$useId, filterDOMProps as $1Hnir$filterDOMProps, mergeProps as $1Hnir$mergeProps, useEffectEvent as $1Hnir$useEffectEvent, useLayoutEffect as $1Hnir$useLayoutEffect, useSlotId as $1Hnir$useSlotId } from "@react-aria/utils";
import { useLocalizedStringFormatter as $1Hnir$useLocalizedStringFormatter, useLocale as $1Hnir$useLocale } from "@react-aria/i18n";
import { useLongPress as $1Hnir$useLongPress, usePress as $1Hnir$usePress, useHover as $1Hnir$useHover, isFocusVisible as $1Hnir$isFocusVisible, useKeyboard as $1Hnir$useKeyboard } from "@react-aria/interactions";
import { useOverlayTrigger as $1Hnir$useOverlayTrigger } from "@react-aria/overlays";
import { useSelectableList as $1Hnir$useSelectableList, useSelectableItem as $1Hnir$useSelectableItem } from "@react-aria/selection";
import { focusSafely as $1Hnir$focusSafely } from "@react-aria/focus";
import { getItemCount as $1Hnir$getItemCount } from "@react-stately/collections";
import { useRef as $1Hnir$useRef, useCallback as $1Hnir$useCallback } from "react";
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
    * Copyright 2020 Adobe. All rights reserved.
    * This file is licensed to you under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License. You may obtain a copy
    * of the License at http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software distributed under
    * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
    * OF ANY KIND, either express or implied. See the License for the specific language
    * governing permissions and limitations under the License.
    */
var $9bdd31893c9700c3$exports = {};
var $c0398ad35c3639b7$exports = {};
$c0398ad35c3639b7$exports = {
  "longPressMessage": "\u0627\u0636\u063A\u0637 \u0645\u0637\u0648\u0644\u0627\u064B \u0623\u0648 \u0627\u0636\u063A\u0637 \u0639\u0644\u0649 Alt + \u0627\u0644\u0633\u0647\u0645 \u0644\u0623\u0633\u0641\u0644 \u0644\u0641\u062A\u062D \u0627\u0644\u0642\u0627\u0626\u0645\u0629"
};
var $7af657c4165927c3$exports = {};
$7af657c4165927c3$exports = {
  "longPressMessage": "\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435\u043B\u043D\u043E \u0438\u043B\u0438 \u043D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 Alt+ \u0441\u0442\u0440\u0435\u043B\u043A\u0430 \u043D\u0430\u0434\u043E\u043B\u0443, \u0437\u0430 \u0434\u0430 \u043E\u0442\u0432\u043E\u0440\u0438\u0442\u0435 \u043C\u0435\u043D\u044E\u0442\u043E"
};
var $d95d4da6d531ab81$exports = {};
$d95d4da6d531ab81$exports = {
  "longPressMessage": "Dlouh\xFDm stiskem nebo stisknut\xEDm kl\xE1ves Alt + \u0161ipka dol\u016F otev\u0159ete nab\xEDdku"
};
var $24ebda9c775dca17$exports = {};
$24ebda9c775dca17$exports = {
  "longPressMessage": "Langt tryk eller tryk p\xE5 Alt + pil ned for at \xE5bne menuen"
};
var $743e0dfca6cab1e9$exports = {};
$743e0dfca6cab1e9$exports = {
  "longPressMessage": "Dr\xFCcken Sie lange oder dr\xFCcken Sie Alt + Nach-unten, um das Men\xFC zu \xF6ffnen"
};
var $a2f41026e05f1c84$exports = {};
$a2f41026e05f1c84$exports = {
  "longPressMessage": "\u03A0\u03B9\u03AD\u03C3\u03C4\u03B5 \u03C0\u03B1\u03C1\u03B1\u03C4\u03B5\u03C4\u03B1\u03BC\u03AD\u03BD\u03B1 \u03AE \u03C0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 Alt + \u03BA\u03AC\u03C4\u03C9 \u03B2\u03AD\u03BB\u03BF\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B1\u03BD\u03BF\u03AF\u03BE\u03B5\u03C4\u03B5 \u03C4\u03BF \u03BC\u03B5\u03BD\u03BF\u03CD"
};
var $43b800e97c901737$exports = {};
$43b800e97c901737$exports = {
  "longPressMessage": "Long press or press Alt + ArrowDown to open menu"
};
var $442f5f6ac211e29f$exports = {};
$442f5f6ac211e29f$exports = {
  "longPressMessage": "Mantenga pulsado o pulse Alt + flecha abajo para abrir el men\xFA"
};
var $dff280acfeb2d8ac$exports = {};
$dff280acfeb2d8ac$exports = {
  "longPressMessage": "Men\xFC\xFC avamiseks vajutage pikalt v\xF5i vajutage klahve Alt + allanool"
};
var $51608325613944d7$exports = {};
$51608325613944d7$exports = {
  "longPressMessage": "Avaa valikko painamalla pohjassa tai n\xE4pp\xE4inyhdistelm\xE4ll\xE4 Alt + Alanuoli"
};
var $c4a1b1eabeaa87be$exports = {};
$c4a1b1eabeaa87be$exports = {
  "longPressMessage": "Appuyez de mani\xE8re prolong\xE9e ou appuyez sur Alt\xA0+\xA0Fl\xE8che vers le bas pour ouvrir le menu."
};
var $8c74815cdee18d1b$exports = {};
$8c74815cdee18d1b$exports = {
  "longPressMessage": "\u05DC\u05D7\u05E5 \u05DC\u05D7\u05D9\u05E6\u05D4 \u05D0\u05E8\u05D5\u05DB\u05D4 \u05D0\u05D5 \u05D4\u05E7\u05E9 Alt + ArrowDown \u05DB\u05D3\u05D9 \u05DC\u05E4\u05EA\u05D5\u05D7 \u05D0\u05EA \u05D4\u05EA\u05E4\u05E8\u05D9\u05D8"
};
var $fd0e9ef6a7fe0ec9$exports = {};
$fd0e9ef6a7fe0ec9$exports = {
  "longPressMessage": "Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika"
};
var $a89a74a39eba465a$exports = {};
$a89a74a39eba465a$exports = {
  "longPressMessage": "Nyomja meg hosszan, vagy nyomja meg az Alt + lefele ny\xEDl gombot a men\xFC megnyit\xE1s\xE1hoz"
};
var $edc7c66594a0ae8a$exports = {};
$edc7c66594a0ae8a$exports = {
  "longPressMessage": "Premere a lungo o premere Alt + Freccia gi\xF9 per aprire il menu"
};
var $f1ab51510712db52$exports = {};
$f1ab51510712db52$exports = {
  "longPressMessage": "\u9577\u62BC\u3057\u307E\u305F\u306F Alt+\u4E0B\u77E2\u5370\u30AD\u30FC\u3067\u30E1\u30CB\u30E5\u30FC\u3092\u958B\u304F"
};
var $f9b672d9b82fa3d6$exports = {};
$f9b672d9b82fa3d6$exports = {
  "longPressMessage": "\uAE38\uAC8C \uB204\uB974\uAC70\uB098 Alt + \uC544\uB798\uCABD \uD654\uC0B4\uD45C\uB97C \uB20C\uB7EC \uBA54\uB274 \uC5F4\uAE30"
};
var $a385f3910feda499$exports = {};
$a385f3910feda499$exports = {
  "longPressMessage": "Nor\u0117dami atidaryti meniu, nuspaud\u0119 palaikykite arba paspauskite \u201EAlt + ArrowDown\u201C."
};
var $4f1bde932c441789$exports = {};
$4f1bde932c441789$exports = {
  "longPressMessage": "Lai atv\u0113rtu izv\u0113lni, turiet nospiestu vai nospiediet tausti\u0146u kombin\u0101ciju Alt + lejupv\u0113rst\u0101 bulti\u0146a"
};
var $914a51a8a594d5be$exports = {};
$914a51a8a594d5be$exports = {
  "longPressMessage": "Langt trykk eller trykk Alt + PilNed for \xE5 \xE5pne menyen"
};
var $89aaf803103bb500$exports = {};
$89aaf803103bb500$exports = {
  "longPressMessage": "Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen"
};
var $c685891476dbaaca$exports = {};
$c685891476dbaaca$exports = {
  "longPressMessage": "Naci\u015Bnij i przytrzymaj lub naci\u015Bnij klawisze Alt + Strza\u0142ka w d\xF3\u0142, aby otworzy\u0107 menu"
};
var $885879b9b10c2959$exports = {};
$885879b9b10c2959$exports = {
  "longPressMessage": "Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu"
};
var $6b39616688a51692$exports = {};
$6b39616688a51692$exports = {
  "longPressMessage": "Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu"
};
var $f26362aed63f47e2$exports = {};
$f26362aed63f47e2$exports = {
  "longPressMessage": "Ap\u0103sa\u021Bi lung sau ap\u0103sa\u021Bi pe Alt + s\u0103geat\u0103 \xEEn jos pentru a deschide meniul"
};
var $06cbade644558bf0$exports = {};
$06cbade644558bf0$exports = {
  "longPressMessage": "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0438 \u0443\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0439\u0442\u0435 \u0438\u043B\u0438 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 Alt + \u0421\u0442\u0440\u0435\u043B\u043A\u0430 \u0432\u043D\u0438\u0437, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u043A\u0440\u044B\u0442\u044C \u043C\u0435\u043D\u044E"
};
var $0a391ff68f9d59b1$exports = {};
$0a391ff68f9d59b1$exports = {
  "longPressMessage": "Ponuku otvor\xEDte dlh\xFDm stla\u010Den\xEDm alebo stla\u010Den\xEDm kl\xE1vesu Alt + kl\xE1vesu so \u0161\xEDpkou nadol"
};
var $8193cf0e649c7928$exports = {};
$8193cf0e649c7928$exports = {
  "longPressMessage": "Za odprtje menija pritisnite in dr\u017Eite gumb ali pritisnite Alt+pu\u0161\u010Dica navzdol"
};
var $f398debcce5a5c55$exports = {};
$f398debcce5a5c55$exports = {
  "longPressMessage": "Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni"
};
var $9e9fef000aa4c013$exports = {};
$9e9fef000aa4c013$exports = {
  "longPressMessage": "H\xE5ll nedtryckt eller tryck p\xE5 Alt + pil ned\xE5t f\xF6r att \xF6ppna menyn"
};
var $c016c8183bbe3d68$exports = {};
$c016c8183bbe3d68$exports = {
  "longPressMessage": "Men\xFCy\xFC a\xE7mak i\xE7in uzun bas\u0131n veya Alt + A\u015Fa\u011F\u0131 Ok tu\u015Funa bas\u0131n"
};
var $ca4f6c8462244e62$exports = {};
$ca4f6c8462244e62$exports = {
  "longPressMessage": "\u0414\u043E\u0432\u0433\u043E \u0430\u0431\u043E \u0437\u0432\u0438\u0447\u0430\u0439\u043D\u043E \u043D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u043A\u043E\u043C\u0431\u0456\u043D\u0430\u0446\u0456\u044E \u043A\u043B\u0430\u0432\u0456\u0448 Alt \u0456 \u0441\u0442\u0440\u0456\u043B\u043A\u0430 \u0432\u043D\u0438\u0437, \u0449\u043E\u0431 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043C\u0435\u043D\u044E"
};
var $2d9960c02ccac927$exports = {};
$2d9960c02ccac927$exports = {
  "longPressMessage": "\u957F\u6309\u6216\u6309 Alt + \u5411\u4E0B\u65B9\u5411\u952E\u4EE5\u6253\u5F00\u83DC\u5355"
};
var $f1b682a4c8c5631c$exports = {};
$f1b682a4c8c5631c$exports = {
  "longPressMessage": "\u9577\u6309\u6216\u6309 Alt+\u5411\u4E0B\u9375\u4EE5\u958B\u555F\u529F\u80FD\u8868"
};
$9bdd31893c9700c3$exports = {
  "ar-AE": $c0398ad35c3639b7$exports,
  "bg-BG": $7af657c4165927c3$exports,
  "cs-CZ": $d95d4da6d531ab81$exports,
  "da-DK": $24ebda9c775dca17$exports,
  "de-DE": $743e0dfca6cab1e9$exports,
  "el-GR": $a2f41026e05f1c84$exports,
  "en-US": $43b800e97c901737$exports,
  "es-ES": $442f5f6ac211e29f$exports,
  "et-EE": $dff280acfeb2d8ac$exports,
  "fi-FI": $51608325613944d7$exports,
  "fr-FR": $c4a1b1eabeaa87be$exports,
  "he-IL": $8c74815cdee18d1b$exports,
  "hr-HR": $fd0e9ef6a7fe0ec9$exports,
  "hu-HU": $a89a74a39eba465a$exports,
  "it-IT": $edc7c66594a0ae8a$exports,
  "ja-JP": $f1ab51510712db52$exports,
  "ko-KR": $f9b672d9b82fa3d6$exports,
  "lt-LT": $a385f3910feda499$exports,
  "lv-LV": $4f1bde932c441789$exports,
  "nb-NO": $914a51a8a594d5be$exports,
  "nl-NL": $89aaf803103bb500$exports,
  "pl-PL": $c685891476dbaaca$exports,
  "pt-BR": $885879b9b10c2959$exports,
  "pt-PT": $6b39616688a51692$exports,
  "ro-RO": $f26362aed63f47e2$exports,
  "ru-RU": $06cbade644558bf0$exports,
  "sk-SK": $0a391ff68f9d59b1$exports,
  "sl-SI": $8193cf0e649c7928$exports,
  "sr-SP": $f398debcce5a5c55$exports,
  "sv-SE": $9e9fef000aa4c013$exports,
  "tr-TR": $c016c8183bbe3d68$exports,
  "uk-UA": $ca4f6c8462244e62$exports,
  "zh-CN": $2d9960c02ccac927$exports,
  "zh-TW": $f1b682a4c8c5631c$exports
};
function $168583247155ddda$export$dc9c12ed27dd1b49(props, state, ref) {
  var _props$type = props.type,
    type = _props$type === void 0 ? "menu" : _props$type,
    isDisabled = props.isDisabled,
    _props$trigger = props.trigger,
    trigger = _props$trigger === void 0 ? "press" : _props$trigger;
  var menuTriggerId = (0, $1Hnir$useId)();
  var _ref = (0, $1Hnir$useOverlayTrigger)({
      type: type
    }, state, ref),
    triggerProps = _ref.triggerProps,
    overlayProps = _ref.overlayProps;
  var onKeyDown = function onKeyDown(e) {
    if (isDisabled) return;
    if (trigger === "longPress" && !e.altKey) return;
    if (ref && ref.current) switch (e.key) {
      case "Enter":
      case " ":
        if (trigger === "longPress") return;
      // fallthrough
      case "ArrowDown":
        // Stop propagation, unless it would already be handled by useKeyboard.
        if (!("continuePropagation" in e)) e.stopPropagation();
        e.preventDefault();
        state.toggle("first");
        break;
      case "ArrowUp":
        if (!("continuePropagation" in e)) e.stopPropagation();
        e.preventDefault();
        state.toggle("last");
        break;
    }
  };
  var stringFormatter = (0, $1Hnir$useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($9bdd31893c9700c3$exports)));
  var _ref2 = (0, $1Hnir$useLongPress)({
      isDisabled: isDisabled || trigger !== "longPress",
      accessibilityDescription: stringFormatter.format("longPressMessage"),
      onLongPressStart: function onLongPressStart() {
        state.close();
      },
      onLongPress: function onLongPress() {
        state.open("first");
      }
    }),
    longPressProps = _ref2.longPressProps;
  var pressProps = {
    onPressStart: function onPressStart(e) {
      // For consistency with native, open the menu on mouse/key down, but touch up.
      if (e.pointerType !== "touch" && e.pointerType !== "keyboard" && !isDisabled)
        // If opened with a screen reader, auto focus the first item.
        // Otherwise, the menu itself will be focused.
        state.toggle(e.pointerType === "virtual" ? "first" : null);
    },
    onPress: function onPress(e) {
      if (e.pointerType === "touch" && !isDisabled) state.toggle();
    }
  };
  // omit onPress from triggerProps since we override it above.
  delete triggerProps.onPress;
  return {
    menuTriggerProps: _objectSpread(_objectSpread(_objectSpread({}, triggerProps), trigger === "press" ? pressProps : longPressProps), {}, {
      id: menuTriggerId,
      onKeyDown: onKeyDown
    }),
    menuProps: _objectSpread(_objectSpread({}, overlayProps), {}, {
      "aria-labelledby": menuTriggerId,
      autoFocus: state.focusStrategy || true,
      onClose: state.close
    })
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

var $d5336fe17ce95402$export$6f49b4016bfc8d56 = new WeakMap();
function $d5336fe17ce95402$export$38eaa17faae8f579(props, state, ref) {
  var _props$shouldFocusWra = props.shouldFocusWrap,
    shouldFocusWrap = _props$shouldFocusWra === void 0 ? true : _props$shouldFocusWra,
    otherProps = _objectWithoutProperties(props, _excluded);
  if (!props["aria-label"] && !props["aria-labelledby"]) console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
  var domProps = (0, $1Hnir$filterDOMProps)(props, {
    labelable: true
  });
  var _ref3 = (0, $1Hnir$useSelectableList)(_objectSpread(_objectSpread({}, otherProps), {}, {
      ref: ref,
      selectionManager: state.selectionManager,
      collection: state.collection,
      disabledKeys: state.disabledKeys,
      shouldFocusWrap: shouldFocusWrap
    })),
    listProps = _ref3.listProps;
  $d5336fe17ce95402$export$6f49b4016bfc8d56.set(state, {
    onClose: props.onClose,
    onAction: props.onAction
  });
  return {
    menuProps: (0, $1Hnir$mergeProps)(domProps, _objectSpread(_objectSpread({
      role: "menu"
    }, listProps), {}, {
      onKeyDown: function onKeyDown(e) {
        // don't clear the menu selected keys if the user is presses escape since escape closes the menu
        if (e.key !== "Escape") listProps.onKeyDown(e);
      }
    }))
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $a2e5df62f93c7633$export$9d32628fc2aea7da(props, state, ref) {
  var key = props.key,
    closeOnSelect = props.closeOnSelect,
    isVirtualized = props.isVirtualized,
    hasPopup = props["aria-haspopup"];
  var _ref4 = (0, $1Hnir$useLocale)(),
    direction = _ref4.direction;
  var isMenuDialogTrigger = state.collection.getItem(key).hasChildNodes;
  var isOpen = state.expandedKeys.has(key);
  var _props_isDisabled;
  var isDisabled = (_props_isDisabled = props.isDisabled) !== null && _props_isDisabled !== void 0 ? _props_isDisabled : state.disabledKeys.has(key);
  var _props_isSelected;
  var isSelected = (_props_isSelected = props.isSelected) !== null && _props_isSelected !== void 0 ? _props_isSelected : state.selectionManager.isSelected(key);
  var openTimeout = (0, $1Hnir$useRef)();
  var cancelOpenTimeout = (0, $1Hnir$useCallback)(function () {
    if (openTimeout.current) {
      clearTimeout(openTimeout.current);
      openTimeout.current = undefined;
    }
  }, [openTimeout]);
  var onSubmenuOpen = (0, $1Hnir$useEffectEvent)(function () {
    cancelOpenTimeout();
    if (!state.expandedKeys.has(key)) state.toggleKey(key);
  });
  (0, $1Hnir$useLayoutEffect)(function () {
    return function () {
      return cancelOpenTimeout();
    };
  }, [cancelOpenTimeout]);
  var data = (0, $d5336fe17ce95402$export$6f49b4016bfc8d56).get(state);
  var onClose = props.onClose || data.onClose;
  var onActionMenuDialogTrigger = (0, $1Hnir$useCallback)(function () {
    onSubmenuOpen();
    // will need to disable this lint rule when using useEffectEvent https://react.dev/learn/separating-events-from-effects#logic-inside-effects-is-reactive
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var onAction = isMenuDialogTrigger ? onActionMenuDialogTrigger : props.onAction || data.onAction;
  var role = "menuitem";
  if (state.selectionManager.selectionMode === "single") role = "menuitemradio";else if (state.selectionManager.selectionMode === "multiple") role = "menuitemcheckbox";
  var labelId = (0, $1Hnir$useSlotId)();
  var descriptionId = (0, $1Hnir$useSlotId)();
  var keyboardId = (0, $1Hnir$useSlotId)();
  var ariaProps = {
    "aria-disabled": isDisabled || undefined,
    role: role,
    "aria-label": props["aria-label"],
    "aria-labelledby": labelId,
    "aria-describedby": [descriptionId, keyboardId].filter(Boolean).join(" ") || undefined
  };
  if (state.selectionManager.selectionMode !== "none") ariaProps["aria-checked"] = isSelected;
  if (isVirtualized) {
    ariaProps["aria-posinset"] = state.collection.getItem(key).index;
    ariaProps["aria-setsize"] = (0, $1Hnir$getItemCount)(state.collection);
  }
  if (hasPopup != null) {
    ariaProps["aria-haspopup"] = hasPopup;
    ariaProps["aria-expanded"] = isOpen ? "true" : "false";
  }
  var onPressStart = function onPressStart(e) {
    if (e.pointerType === "keyboard" && onAction) onAction(key);
  };
  var onPressUp = function onPressUp(e) {
    if (e.pointerType !== "keyboard") {
      if (onAction) onAction(key);
      // Pressing a menu item should close by default in single selection mode but not multiple
      // selection mode, except if overridden by the closeOnSelect prop.
      if (!isMenuDialogTrigger && onClose && (closeOnSelect !== null && closeOnSelect !== void 0 ? closeOnSelect : state.selectionManager.selectionMode !== "multiple")) onClose();
    }
  };
  var _ref5 = (0, $1Hnir$useSelectableItem)({
      selectionManager: state.selectionManager,
      key: key,
      ref: ref,
      shouldSelectOnPressUp: true,
      allowsDifferentPressOrigin: true
    }),
    itemProps = _ref5.itemProps,
    isFocused = _ref5.isFocused;
  var _ref6 = (0, $1Hnir$usePress)({
      onPressStart: onPressStart,
      onPressUp: onPressUp,
      isDisabled: isDisabled
    }),
    pressProps = _ref6.pressProps,
    isPressed = _ref6.isPressed;
  var _ref7 = (0, $1Hnir$useHover)({
      isDisabled: isDisabled,
      onHoverStart: function onHoverStart() {
        if (!(0, $1Hnir$isFocusVisible)()) {
          state.selectionManager.setFocused(true);
          state.selectionManager.setFocusedKey(key);
          // focus immediately so that a focus scope opened on hover has the correct restore node
          var _isFocused = key === state.selectionManager.focusedKey;
          if (_isFocused && state.selectionManager.isFocused && document.activeElement !== ref.current) {
            if (state.expandedKeys.size > 0 && !state.expandedKeys.has(key)) {
              var _iterator = _createForOfIteratorHelper(state.expandedKeys),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var expandedKey = _step.value;
                  state.toggleKey(expandedKey);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            }
            (0, $1Hnir$focusSafely)(ref.current);
          }
        }
      },
      onHoverChange: function onHoverChange(isHovered) {
        if (isHovered && isMenuDialogTrigger) {
          if (!openTimeout.current) openTimeout.current = setTimeout(function () {
            onSubmenuOpen();
          }, 200);
        } else if (!isHovered) cancelOpenTimeout();
      }
    }),
    hoverProps = _ref7.hoverProps;
  var _ref8 = (0, $1Hnir$useKeyboard)({
      onKeyDown: function onKeyDown(e) {
        // Ignore repeating events, which may have started on the menu trigger before moving
        // focus to the menu item. We want to wait for a second complete key press sequence.
        if (e.repeat) {
          e.continuePropagation();
          return;
        }
        switch (e.key) {
          case " ":
            if (!isDisabled && state.selectionManager.selectionMode === "none" && !isMenuDialogTrigger && closeOnSelect !== false && onClose) onClose();
            break;
          case "Enter":
            // The Enter key should always close on select, except if overridden.
            if (!isDisabled && closeOnSelect !== false && !isMenuDialogTrigger && onClose) onClose();
            break;
          case "ArrowRight":
            if (isMenuDialogTrigger && direction === "ltr") onSubmenuOpen();else e.continuePropagation();
            break;
          case "ArrowLeft":
            if (isMenuDialogTrigger && direction === "rtl") onSubmenuOpen();else e.continuePropagation();
            break;
          default:
            e.continuePropagation();
            break;
        }
      }
    }),
    keyboardProps = _ref8.keyboardProps;
  return {
    menuItemProps: _objectSpread(_objectSpread({}, ariaProps), (0, $1Hnir$mergeProps)(itemProps, pressProps, hoverProps, keyboardProps)),
    labelProps: {
      id: labelId
    },
    descriptionProps: {
      id: descriptionId
    },
    keyboardShortcutProps: {
      id: keyboardId
    },
    isFocused: isFocused,
    isSelected: isSelected,
    isPressed: isPressed,
    isDisabled: isDisabled
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
function $3e5eb2498db5b506$export$73f7a44322579622(props) {
  var heading = props.heading,
    ariaLabel = props["aria-label"];
  var headingId = (0, $1Hnir$useId)();
  return {
    itemProps: {
      role: "presentation"
    },
    headingProps: heading ? {
      // Techincally, menus cannot contain headings according to ARIA.
      // We hide the heading from assistive technology, and only use it
      // as a label for the nested group.
      id: headingId,
      "aria-hidden": true
    } : {},
    groupProps: {
      role: "group",
      "aria-label": ariaLabel,
      "aria-labelledby": heading ? headingId : undefined
    }
  };
}
export { $168583247155ddda$export$dc9c12ed27dd1b49 as useMenuTrigger, $d5336fe17ce95402$export$38eaa17faae8f579 as useMenu, $a2e5df62f93c7633$export$9d32628fc2aea7da as useMenuItem, $3e5eb2498db5b506$export$73f7a44322579622 as useMenuSection };